import { Button, FlexBox, Icon, Typography } from '@vp/swan'
import { useEffect, useRef } from 'react'
import { useUploadsStore } from '../../UploadsProvider'
import { SCHEME_KEYS, usePersonalizationManager } from '../../PersonalizationManager'
import { usePersonalizationConfig } from '../../hooks/usePersonalizationConfig'
import { useSchemeUploads } from '../../../Schemes/hooks/useSchemeUploads'

export interface UploadsModalOpenButtonProps {
  onClick: () => void
}

export const UploadsModalOpenButton = (props: UploadsModalOpenButtonProps) => {
  const { onClick } = props
  const { mobileModalOpen, translations, tracking } = usePersonalizationManager()
  const { uploadsCopy } = translations

  const { uploads } = useSchemeUploads(SCHEME_KEYS.MANUAL)
  const { mode } = usePersonalizationConfig()
  const { selectedUploads } = useUploadsStore()
  const imageButtonRef = useRef<HTMLInputElement>(null)

  const previewUploads = mode === 'modal' ? selectedUploads : uploads
  const previewUploadsLength = previewUploads.length

  useEffect(() => {
    if (mobileModalOpen) {
      imageButtonRef.current?.focus()
    }
  }, [mobileModalOpen])

  useEffect(() => {
    const imageButtonFocusTimeout = setTimeout(() => {
      if (mobileModalOpen) {
        imageButtonRef.current?.focus()
      }
    }, 100)

    // Cleanup timeout on unmount or dependency change
    return () => clearTimeout(imageButtonFocusTimeout)
  }, [mobileModalOpen])

  const handleClick = (): void => {
    onClick()
    if (selectedUploads.length) {
      tracking.changeImage()
    } else {
      tracking.addImage()
    }
  }

  return (
    <Button iconPosition="left" id="personalization-image-modal-open-button" ref={imageButtonRef} width="full-width" onClick={handleClick}>
      {previewUploadsLength ? (
        <>
          <FlexBox>
            <Icon
              objectFit={'contain'}
              backgroundColor="transparent"
              className="personalization-change-image-button-icon"
              size="28p"
              src={previewUploads[0].asset.thumbnail.getUrl()}
            />
            {previewUploadsLength > 1 && (
              <FlexBox alignItems="center" className="personalization-additional-images-icon" justifyContent="center">
                <Typography fontSize="small">{`+${previewUploadsLength - 1}`}</Typography>
              </FlexBox>
            )}
          </FlexBox>
          <span>{uploadsCopy.changeImageButton}</span>
        </>
      ) : (
        <>
          <Icon iconType="image" size="20p" />
          <span>{uploadsCopy.addImageButton}</span>
        </>
      )}
    </Button>
  )
}
